<template>
  <v-bottom-navigation
    :value="activeBtn"
    grow
    fixed
    bottom
    class="brand-primary bottom-nav-btn"
    app
  >
    <BaseButton
      to="/courses"
      :ripple="false"
    >
      <font-awesome-icon icon="fa-regular fa-list" />
    </BaseButton>

    <BaseButton
      :ripple="false"
      to="/subscriptions"
    >
      <font-awesome-icon icon="fa-regular fa-backpack" />
    </BaseButton>

    <BaseButton
      :ripple="false"
      to="/profile"
    >
      <font-awesome-icon icon="fa-regular fa-user" />
    </BaseButton>
  </v-bottom-navigation>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'TheNavBar',
  components: {
    BaseButton,
  },
  props: {
    activeBtn: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
  .bottom-nav-btn {
    .v-btn__content {
      color: var(--v-brand-primary-tone-300);
    }
  }

  .v-item-group.v-bottom-navigation .v-btn.v-btn--active {
    .v-btn__content {
      color: var(--v-white-base)!important;
    }
  }
</style>
